import * as React from "react";
import { TextField, InputAdornment, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// Rounded pill search field with a leading search icon and a trailing live result count.
export default function PillSearchField({ value, onChange, placeholder, resultCount, loading, sx }) {
  return (
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        "& .MuiOutlinedInput-root": { borderRadius: 1.5, backgroundColor: "#fff" },
        ...sx,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "#9e9e9e" }} />
          </InputAdornment>
        ),
        endAdornment: !loading && resultCount != null && (
          <InputAdornment position="end">
            <Typography variant="body2" sx={{ color: "#9e9e9e", whiteSpace: "nowrap" }}>
              {resultCount} results
            </Typography>
          </InputAdornment>
        ),
      }}
    />
  );
}
